import { useState } from "react";
import { Stack } from "@mui/material";
import CircledBackButton from "@/features/Common/components/CircledBackButton";
import BuyVoucherTab from "../BuyVoucherTab";
import UseVoucherTab from "../UseVoucherTab";
import TightTabs from "../../../Common/components/TightTabs";
import { Vouchers, VoucherType } from "@/services/core-api-adapter";
import { defaultFullscreenPageStyling } from "@/theme";

interface AddOrUseVoucherPageProps {
  voucher: Vouchers | undefined;
  onDoctorNurseConsultationVoucherClicked: (voucher: VoucherType) => void;
  onPathologyTestVoucherClicked: (voucher: VoucherType) => void;
  onGetSupportClicked: () => void;
  onApplyVoucherClicked: (voucherCode: string) => void;
  applyVoucherError: any;
  preselectedTab?: string;
  onBackButtonClick?: () => void;
  onBuyVoucherClicked?: () => void;
  onUseVoucherClicked?: () => void;
  voucherCode?: string | undefined;
}

export default function AddOrUseVoucherPage({
  voucher,
  onPathologyTestVoucherClicked,
  onDoctorNurseConsultationVoucherClicked,
  onGetSupportClicked,
  onApplyVoucherClicked,
  applyVoucherError,
  preselectedTab = "buy-voucher",
  onBackButtonClick,
  onUseVoucherClicked,
  onBuyVoucherClicked,
  voucherCode,
}: AddOrUseVoucherPageProps) {
  const [selectedTab, setSelectedTab] = useState<string>(preselectedTab);
  const labels = [
    "AddOrUseVoucher.Voucher.BuyVoucherTab.title",
    "AddOrUseVoucher.Voucher.UseVoucherTab.title",
  ];

  return (
    <Stack spacing={2} sx={{ ...defaultFullscreenPageStyling }}>
      <CircledBackButton showLabel={true} onClick={onBackButtonClick} />

      <Stack spacing={3}>
        <TightTabs
          selectedTab={selectedTab}
          baseRoute="/home/my-vouchers"
          setSelectedTab={setSelectedTab}
          labels={labels}
          onTabOneClicked={onBuyVoucherClicked}
          onTabTwoClicked={onUseVoucherClicked}
        />

        {selectedTab === "buy-voucher" && (
          <BuyVoucherTab
            voucher={voucher}
            onDoctorNurseConsultationVoucherClicked={
              onDoctorNurseConsultationVoucherClicked
            }
            onPathologyTestVoucherClicked={onPathologyTestVoucherClicked}
          />
        )}
        {selectedTab === "use-voucher" && (
          <UseVoucherTab
            applyVoucherError={applyVoucherError}
            onGetSupportClick={onGetSupportClicked}
            onApplyVoucherClick={onApplyVoucherClicked}
            voucherCode={voucherCode}
          />
        )}
      </Stack>
    </Stack>
  );
}
